import styled from 'styled-components';
import InputBase, { InputAdornment } from 'components/InputBase';
import { Dropdown } from 'icons';
import { getThemeColor } from 'utils/styled';
import { SelectStyleProps } from './types';

export const SelectRoot = styled.div<SelectStyleProps>`
  display: inline-block;

  ${({ $fluid }) => $fluid && 'width: 100%;'}
`;

export const Trigger = styled(InputBase)`
  font-weight: normal;
  font-size: 16px;
  letter-spacing: normal;
  text-align: left;
  text-transform: none;
  width: 100%;

  &:active:not([disabled]) {
    box-shadow: none;
  }

  &::after {
    border-color: ${getThemeColor('l5')};
  }
`;

export const Adornment = styled(InputAdornment)`
  color: ${getThemeColor('d5')};
`;

export const Arrow = styled(Dropdown)`
  height: 4px;
  width: 7px;
`;
